import { Box } from '@mui/material';
import Image from 'next/image';
import React, { ReactNode } from 'react'
import { makeStyles } from 'tss-react/mui'
type props={
    children:ReactNode,
    image:string
}
export default function Layout({children,image}:props) {
    const {classes}=styles();
  return (
    <Box className={`${classes.container} `}>
        <Box className={`${classes.left}`}>
            {children}
        </Box>
        <Box className={`${classes.right} `}>
            <Image 
              src={image||"/images/explore/explore.svg"}
               objectFit='cover'
                fill 
                alt="Property listings"/>
        </Box>
    </Box>
  )
}

const styles=makeStyles()((theme)=>({
    container:{
     display:'grid',
     gridTemplateColumns:'1fr 1.3fr',
     gridTemplateRows:'1fr',
     height:'100vh'
    },
    debug:{
    border:'1px solid green'
    },
    left:{
     display:'flex',
     flexDirection:'column',
     gap:theme.spacing(3),
     justifyContent:'center',
     alignItems:'center'
    }, 
    right:{
     position:'relative',
     width:'100%',
     flex:1
    }
}))